import { RouteConfig } from "vue-router";
import ROUTES from "../routes";

export const PublicRoutes: Array<RouteConfig> = [
  {
    path: "/public/map/:z?,:x?,:y?",
    alias: ["/public/map"],
    name: ROUTES.PUBLIC_MAP,
  },
];
